module.exports = __webpack_public_path__ + "img/advisor-icon.395731e1.png";